<template>
  <div class="content solicitantes p-1">
    <h4 class="solicitantes_title">
      <b>Solicitantes</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label for="busca"
                   class="solicitantes_label">Buscar Solicitante</label>
            <input id="busca"
                   v-model="search"
                   class="col-md-12 form-control form-control-sm"
                   name="busca"
                   placeholder="Digite o nome do solicitante"
                   type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button variant="secondary"
                      size="sm"
                      @click="showModal()">
              <svg class="button_edit_label_icon icon--xxs"
                   role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar Solicitante
            </b-button>
          </div>
        </div>
      </b-row>
      <Table
        :fields="fields"
        :data="solicitantes"
        :is-busy="isBusy"
        :search="search"
        field-search="nome"
        @deleteItem="deleteSolicitante"
        @showModal="showModal"
        @onUpdateAtivo="updateAtivo" />

      <Pagination
        :per-page="perPage"
        :page="page"
        :last-page="lastPage"
        @onPreviousPage="previousPage"
        @onNextPage="nextPage" />

      <form autocomplete="off"
            class="no-padding"
            @submit.prevent="callMethod()">
        <BoxModal :read="read"
                  :form="form"
                  :tipo="'Solicitante'"
                  @changeRead="changeRead"
                  @onEnderecoAdd="changeData" />
      </form>
    </div>
  </div>
</template>
<script>
  /* components */
  import Table from '@/components/SofiaRei/Table'
  import Pagination from '@/components/SofiaRei/Pagination'
  import BoxModal from '@/components/SofiaRei/Cruds/BoxModal'

  /* services  */
  import SolicitantesService from "@/services/Registros/SolicitantesService"

  /* assets */
  import add from '@/assets/icons/add.svg?sprite'
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"

  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'


  export default {
    name: 'Solicitantes',
    components: {
      Table,
      Pagination,
      BoxModal
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        add,
        editIcon,
        eyeIcon,
        read: false,
        title: 'Novo Solicitante',
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'cpf',
          label: 'CPF'
        },{
          key: 'nome',
          label: 'Nome'
        },{
          key: 'acoes2',
          label: ''
        }],
        solicitantes: [],
        form: {
          cpf: null,
          nome: null,
          telefone: null,
          celular: null,
          email: null,
          endereco: {
            cep: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cidade: null,
            uf: null,
            codigo_ibge_id: null
          },
          editar: null
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    beforeMount () {
      try {
        loader({text: "Obtendo dados...", active: true})
        this.init()
      } catch (error) {
        loader({text: "", active: false})
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchSolicitante()
      }, 200)
    },
    methods: {
      async init () {
        const solicitantes = await SolicitantesService.getSolicitantes ({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page
        })
        this.solicitantes = solicitantes.data
        this.solicitantes.map((solicitante) => {
          solicitante.cpf = this.maskCpf(solicitante)
        })
        this.lastPage = solicitantes.lastPage
        this.isBusy = false
        loader({ text: "", active: false})
      },
      async showModal (solicitante = { data: {}, read: false }) {
        const {data, read} = solicitante
        this.read = read
        if (data.solicitante_id) {
          this.form.solicitante_id = data.solicitante_id
          this.form.cpf = data.cpf
          this.form.nome = data.nome
          this.form.telefone = data.telefone
          this.form.celular = data.celular
          this.form.email = data.email
          this.form.endereco = data.endereco
          this.form.editar = true
        } else {
          this.form = {
            cartorio_id: this.$store.state.auth.cartorio_id,
            cpf: null,
            nome: null,
            telefone: null,
            celular: null,
            email: null,
            endereco: {
              cep: null,
              logradouro: null,
              numero: null,
              complemento: null,
              bairro: null,
              cidade: null,
              uf: null,
              codigo_ibge_id: null
            }
          }
        }
        this.$bvModal.show('modal-cadastro')
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')
        loader({ text: "Aguarde...", active: true})

        if (this.form.solicitante_id) {
          this.updateSolicitante(this.form)
        } else {
          this.saveSolicitante(this.form)
        }
      },
      async saveSolicitante (solicitante) {
        try {
          const data = await SolicitantesService.saveSolicitantes (solicitante)
          if (data.solicitante_id) {
            this.init()
            objSwal.success.title = "Salvo com sucesso!"
            objSwal.success.text = ''
            Swal.fire(objSwal.success)
            loader({ text: "", active: false})
          } else {
            objSwal.warning.title = "Erro ao salvar, tente novamente!"
            Swal.fire(objSwal.warning)
            loader({ text: "", active: false})
          }
        } catch (err) {
          objSwal.warning.title = "Erro ao salvar, tente novamente!"
          Swal.fire(objSwal.warning)
          loader({ text: "", active: false})
        }
      },
      async updateSolicitante (solicitante, alert = true) {
        try {
          const {solicitante_id} = solicitante

          solicitante.cartorio_id = this.$store.state.auth.cartorio_id

          const data = await SolicitantesService.updateSolicitantes (solicitante, solicitante_id)
          if (solicitante_id) {
            if (alert) {
              this.init()
              objSwal.success.title = "Salvo com sucesso!"
              objSwal.success.text = ''
              Swal.fire(objSwal.success)
            }
            loader({ text: "", active: false})
          } else {
            objSwal.warning.title = "Erro ao salvar, tente novamente!"
            Swal.fire(objSwal.warning)
            loader({ text: "", active: false})
          }
        } catch (err) {
          objSwal.warning.title = "Erro ao salvar, tente novamente!"
          Swal.fire(objSwal.warning)
          loader({ text: "", active: false})
        }
      },
      async searchSolicitante () {
        this.isBusy = true
        const solicitantes = await SolicitantesService.getSolicitantes({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.search
        })
        this.solicitantes = solicitantes.data
        this.solicitantes.map((solicitante) => {
          solicitante.cpf = this.maskCpf(solicitante)
        })
        this.lastPage = solicitantes.lastPage
        this.isBusy = false
      },
      onError (title = 'Erro', text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        return Swal.fire(objSwal.error)
      },

      deleteSolicitante (val) {
        objSwal.question.title = ''
        objSwal.question.text = 'Confirma a exclusão deste solicitante?'

        return Swal.fire (objSwal.question).then(result => {
          if (result.value) {
            SolicitantesService.excludeSolicitantes(val.solicitante_id).then(res => {
              this.init()
              objSwal.success.title = 'Solicitante excluído'
              objSwal.success.text = ''
            }).catch(({ message }) => this.onError(`Erro ao deletar solicitante.`, message))
          }
        })
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      updateAtivo (data) {
        this.updateSolicitante(data, false)
      },
      changeRead () {
        this.read = !this.read
      },
      changeData (data) {
        this.form.endereco = data
      },
      maskCpf (solicitante) {
        const cpf = []
        cpf[0] = solicitante.cpf.slice(0,3)
        cpf[1] = solicitante.cpf.slice(3,6)
        cpf[2] = solicitante.cpf.slice(6,9)
        const digito = solicitante.cpf.slice(9,11)
        const newCpf = `${ cpf.join('.') }-${ digito }`
        return newCpf
      }
    }
  }
</script>
<style lang="scss">
  @import "../../scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff
  }

  .solicitantes{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }
</style>
